import { createComponent } from '@carvana/vdp-components';

export const Container = createComponent('div', {
  className: 'bg-white pt-16 m:pt-[25px] m:px-24 l:pt-[33px] l:px-32'
});

export const FiltersResultsContainer = createComponent('div', {
  className: 'gap-32 grid l:grid-cols-[minmax(296px,_352px)_1fr]'
});

export const Main = createComponent('main', {
  className:
    'bg-white gap-y-0 grid grid-rows-[auto_auto_1fr] grow m:gap-y-24 l:gap-y-32'
});
